import App from '@/models/App';
import Profile from '@/models/Profile';

export default class OrderingOrdererApprovalAccount extends App {
    static get entity() {
        return 'OrderingOrdererApprovalAccounts'
    }

    static all() {
        return this.query().with('user').get()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingApprovalSettingId: this.attr(''),
            orderingAccountId: this.attr(''),
            userId: this.attr(''),
            sort: this.attr(''),
            orderingAccount: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            user: this.belongsTo(Profile, 'userId'),
        }
    }

    static apiConfig = {
        actions: {
            fetch(orderingShipId, orderingApprovalSettingId, params) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/approval/${orderingApprovalSettingId}/accounts`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(orderingShipId, orderingApprovalSettingId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/approval/${orderingApprovalSettingId}/accounts`,
                    params,
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            }
        },
    }
}
